import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  loggedin: defineAsyncComponent(() => import("/vercel/path0/layouts/loggedin.vue").then(m => m.default || m)),
  loggedout: defineAsyncComponent(() => import("/vercel/path0/layouts/loggedout.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/vercel/path0/layouts/public.vue").then(m => m.default || m))
}